// extracted by mini-css-extract-plugin
module.exports = {"signup":"_SignUpPage_signup_2BckH","content":"_SignUpPage_content_AJk27"};